<template>
  <div class="contact-info-wrapper">
    <div class="contact-info-container">
      <div class="contact-info-head">
        <div class="text-title-sm text-title-contact">{{ $t('about.contactInfo.headTitle') }}</div>
        <div class="text-subtitle-xl">{{ $t('about.contactInfo.companyName') }}</div>
      </div>
      <div class="contact-info-body">
        <div class="email-list">
          <div class="email-item">
            <div class="text-content-desc-xsm text-email-title">
              {{ $t('about.contactInfo.storeContact') }}
            </div>
            <div class="text-content-desc-xsm">
              {{ contactData.sell }}
            </div>
          </div>
          <div class="email-item">
            <div class="text-content-desc-xsm text-email-title">
              {{ $t('about.contactInfo.collaboration') }}
            </div>
            <div class="text-content-desc-xsm">
              {{ contactData.collaboration }}
            </div>
          </div>
          <div class="email-item">
            <div class="text-content-desc-xsm text-email-title">
              {{ $t('about.contactInfo.business') }}
            </div>
            <div class="text-content-desc-xsm">
              {{ contactData.business }}
            </div>
          </div>
          <div class="email-item">
            <div class="text-content-desc-xsm text-email-title">
              {{ $t('about.contactInfo.media') }}
            </div>
            <div class="text-content-desc-xsm">
              {{ contactData.media }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import contactData from '../../assets/data/contactData';

export default {
  name: 'contact-info',
  data() {
    return {
      contactData,
    };
  },
};
</script>
<style lang="sass" scoped>
.contact-info-wrapper
  --content-width: 80vw
  width: 100%
  .contact-info-container
    width: 100%
    display: flex
    flex-direction: column
    align-items: center
    .contact-info-head
    .contact-info-body
      .email-list
        width: var(--content-width)
        display: flex
        justify-content: space-between
        align-items: center
        flex-wrap: wrap
        margin-top: 40px
        .email-item
          min-width: 240px
          text-align: center
          margin: 16px 0
          .text-email-title
            font-weight: 700

@media screen and (min-width: 1600px)
  .contact-info-wrapper
    --content-width: 75vw

@media screen and (max-width: 768px)
  .contact-info-wrapper
    width: 100%
    .contact-info-container
      width: 100%
      display: flex
      flex-direction: column
      align-items: center
      .contact-info-head
      .contact-info-body
        .email-list
          display: flex
          flex-direction: column

@media screen and (max-width: 576px)
  .contact-info-wrapper
    .contact-info-container
      .contact-info-body
        .email-list
          .email-item
            margin: 12px 0

@media screen and (max-width: 360px)
  .contact-info-wrapper
    .contact-info-container
      .contact-info-body
        .email-list
          margin-top: 24px
          .email-item
            margin: 8px 0

/** iPad Pro */
@media screen and (min-width: 960px) and (min-aspect-ratio: 3/5) and (max-aspect-ratio: 9/10)
  .contact-info-wrapper
    width: 100%
    .contact-info-container
      width: 100%
      display: flex
      flex-direction: column
      align-items: center
      .contact-info-head
      .contact-info-body
        .email-list
          display: flex
          flex-direction: column

</style>
